import * as requestHelpers from './requests';

function getLocations() {
        return requestHelpers.authenticatedGetRequest( '/common/locations/countries' ) 
}

function getGoogleLocationsAutocomplete( location ) {
    return requestHelpers.authenticatedPostRequest( '/common/google/autocomplete/location', { location } );
}

function getMemberLocations() {
    return requestHelpers.authenticatedGetRequest( '/common/google/member-locations' );
}

function postMemberLivingLocation( placeId ) {
    return requestHelpers.authenticatedPostRequest( '/common/google/member-location-form', { place_id: placeId } );
}

function postMemberWillingToWorkLocations( placeIds ) {
    return requestHelpers.authenticatedPostRequest( '/common/google/member-work-location-form', { place_ids: JSON.stringify( placeIds ) } );
}



module.exports = {
    getLocations,
    getGoogleLocationsAutocomplete,
    postMemberLivingLocation,
    postMemberWillingToWorkLocations,
    getMemberLocations,
};



// WEBPACK FOOTER //
// src/client/helpers/locationHelpers.js